/**
 * @file   src\components\SidebarMenu.tsx
 * @brief  Sidebar Menu component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState, useEffect, useNavigate, Offcanvas, Modal, Button, useRef, React } from '../utils/thirdpartyComponents';
import CWOMainMenu from './CWOMainMenu';
import "../components/Offcanvas.scss";
import { pageURLs } from '../utils/pageUrls';
import FullLoader from './FullLoader';
import { getFromLocalStorage } from '../utils/helper';

const CWOSidebarMenu = (props: any) => {
    const { show, onHide } = props;
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState<boolean>(false)

    const [activeLink, setActiveLink] = useState<string>("my-profile")
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    const sidebarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {

        //To hide sidebar menu if clicked outside
        if (show) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show]);



    const handleClickOutside = (event: MouseEvent) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
            // Hide the sidebar when clicking outside
            onHide();
        }
    };

    // To show popup
    const signout = () => {
        setShowLogoutConfirmation(true)
    }

    //Hide ppopup
    const handleOnHide = () => {
        setShowLogoutConfirmation(false)
    }


    // Redirect to login page on confirm
    const ConfirmLogout = async () => {
        setLoading(true)
        localStorage.clear();
        window.location.href = `${process.env.REACT_APP_SITE_URL || ""}`
        // API call to sign up
        // try {
        //     const { data } = await axios.post(AuthApi.LOGOUT);
        //     dispatch(resetAuthState());
        //     localStorage.clear();
        //     if (data?.error == 0) {

        //         navigate(`/${pageURLs.root}`)
        //         setShowLogoutConfirmation(false);
        //     }
        //     else {
        //         // show error message
        //         toaster.toastError(data?.message);
        //     }
        // } catch (error: any) {
        //     throw new Error(error?.response?.data?.message || error?.message);
        // }
    }

    //Redirect to my profile page
    const onMenuClick = (url: string, active_link: string) => {
        navigate(url)
        setActiveLink(active_link)
        onHide()
    }

    const storageData = getFromLocalStorage('CARWASH_OWNER_DATA');
    const userInfo = storageData && storageData !== null ? storageData : null;

    return (
        <Offcanvas show={show} onHide={onHide} placement="end" className="menu-offcanvas">
            <Offcanvas.Header closeButton>
            </Offcanvas.Header>
            <Offcanvas.Body ref={sidebarRef}>
                <CWOMainMenu active_menu={activeLink} shouldFetchSetting={false} />
                <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.my_profile}`, 'my-profile')} className={activeLink === "my-profile" ? 'f-medium active' : 'f-medium'}>My Profile</a>
                {!(userInfo?.userTypeId === 4 && userInfo?.permissionType === 2)
                    && <>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.cwo_paymentinformation}`, 'cwo-paymentinformation')} className={activeLink === 'cwo-paymentinformation' ? 'f-medium active' : 'f-medium'}>Payment Method</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.cwo_app_settings}`, 'cwo-cwo_app_settings')} className={activeLink === 'cwo-cwo_app_settings' ? 'f-medium active' : 'f-medium'}>Custom Branding</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.cwo_text_settings}`, 'cwo-text-settings')} className={activeLink === 'cwo-text-settings' ? 'f-medium active' : 'f-medium'}>Text Settings</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.cwo_referral_program}/1`, 'cwo-referral-program')} className={activeLink === 'cwo-referral-program' ? 'f-medium active' : 'f-medium'}>Referral Programs</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.fleet_management}`, 'fleet-management')} className={activeLink === "fleet-management" ? 'f-medium active' : 'f-medium'}>Fleet</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.gift_card_management}`, 'gift-card-management')} className={activeLink === "gift-card-management" ? 'f-medium active' : 'f-medium'}>Gift Card</a>
                        {/* Temporarily hidden
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.loyalty_program_management}`, 'loyalty-program-management')} className={activeLink === "loyalty-program-management" ? 'f-medium active' : 'f-medium'}>Loyalty Program</a>
                        */}
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.manage_promotions}`, 'manage-promotions')} className={activeLink === "manage-promotions" ? 'f-medium active' : 'f-medium'}>Promotions</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.manage_campaigns}`, 'manage-campaigns')} className={activeLink === "manage-campaigns" ? 'f-medium active' : 'f-medium'}>Campaigns</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.manage_advertisements}/1`, 'manage-advertisements')} className={activeLink === 'manage-advertisements' ? 'f-medium active' : 'f-medium'}>Advertisements</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.location_managers}`, 'location-managers')} className={activeLink === "location-managers" ? 'f-medium active' : 'f-medium'}   >Location Managers</a>
                        <a href={void 0} onClick={() => onMenuClick(`/${pageURLs.cwo_emailtemplates}`, 'email-templates')} className={activeLink === "email-templates" ? 'f-medium active' : 'f-medium'}>Email Templates</a>
                    </>}
                <a href={void 0} onClick={() => signout()} className='f-medium'>Sign Out</a>
            </Offcanvas.Body>

            {/* signout confirmation Modal */}
            <Modal
                show={showLogoutConfirmation}
                onHide={handleOnHide}
                centered
                className='add-modal'
            >
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>Are you sure you want to Sign Out?</h5>
                    <div className="btn-sec d-grid">
                        <Button title="Cancel" variant="light" className="secondary-btn" onClick={handleOnHide}>Cancel</Button>
                        <Button title="Yes" variant="primary" className='primary-btn btn-main m-0' onClick={ConfirmLogout}>Yes</Button>
                    </div>
                </Modal.Body>
                {loading && <FullLoader />}
            </Modal>

        </Offcanvas>

    );
};
export default CWOSidebarMenu;
